import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function RegisterStorageItem (){
  const {user} = useUser()
  let view = contentLayout[modules.RegisterStorageItem]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.RegisterStorageItem.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.RegisterStorageItem}></Index>
 )
}

export default RegisterStorageItem